import {
  PERSONAL_CHAT_NAME_MAX_LENGTH,
  personalChatNameError,
} from "../../../shared/personalChatName";
import { RenameModal } from "../RenameModal";

type Props = {
  initialName: string;
  onClose: () => void;
  onRename: (name: string) => void;
};

export function RenamePersonalChatModal({
  initialName,
  onClose,
  onRename,
}: Props) {
  return (
    <RenameModal
      title="Rename chat"
      inputLabel="Chat name"
      initialName={initialName}
      maxLength={PERSONAL_CHAT_NAME_MAX_LENGTH}
      validateName={personalChatNameError}
      confirmLabel="Rename"
      onClose={onClose}
      onRename={onRename}
    />
  );
}
